import { useIntl } from 'react-intl';

import { Summary } from '@/components/Summary';
import type { UserFragment } from '@/graphql/saleor/api';
import { CONTENTSQUARE_MASKED } from '@/lib/forms/const';
import { commonMessages } from '@/messages/common';
import type { CheckoutState } from '@/states/checkout';

import { getContactPhone } from '../utils';

interface ContactSummaryProps {
  checkout: CheckoutState<true>['checkout'];
  loggedUser?: Partial<UserFragment> | null;
  onEdit: () => void;
}

export const ContactSummary = ({
  checkout: { email, user },
  checkout,
  loggedUser,
  onEdit,
}: ContactSummaryProps) => {
  const { formatMessage } = useIntl();
  const userPhoneNumber = getContactPhone(checkout, loggedUser);
  return (
    <Summary data-test-id='ContactSummary' name='contact'>
      <Summary.Header data-test-id='ContactSummaryHeader' onClick={onEdit}>
        {formatMessage(commonMessages.contactInformation)}
      </Summary.Header>
      <Summary.Section data-test-id='ContactSummarySection'>
        <Summary.Entry data-test-id='ContactSummaryEntry'>
          <Summary.Line
            className={CONTENTSQUARE_MASKED}
            data-test-id='ContactSummaryEntry-Line0'
          >
            {user?.email || email}
          </Summary.Line>
          <Summary.Line
            className={CONTENTSQUARE_MASKED}
            data-test-id='ContactSummaryEntry-Line1'
          >
            {userPhoneNumber}
          </Summary.Line>
        </Summary.Entry>
      </Summary.Section>
    </Summary>
  );
};
